'use strict';

angular.module('mean.contractors').factory('contractorQueryService', ['$q', 'Contractors',
    function($q, Contractors) {
        var getById = function(id) {
            var deferred = $q.defer();

            Contractors.query({'_id': id},
                function(returned_tasks) {
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByBuilderCode = function(code) {
            var deferred = $q.defer();

            Contractors.query({'code': code},
                function(returned_tasks) {
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        var getByName = function(name) {
            var deferred = $q.defer();

            Contractors.query({'name': name},
                function(returned_tasks) {
                deferred.resolve(returned_tasks);
            });

            return deferred.promise;
        };

        return {
            getById: getById,
            getByBuilderCode: getByBuilderCode,
            getByName: getByName
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/contractors/public/services/contractor-query-service.js